import {getImageUrl, Sizes} from '@cohort/shared/utils/media';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import type {CampaignStoreWDto} from '@cohort/wallet-schemas/campaign';
import {htmlToText} from 'html-to-text';
import React from 'react';
import {Helmet} from 'react-helmet-async';
import {useTranslation} from 'react-i18next';

type StoreMetaDataProps = {
  campaign: CampaignStoreWDto;
};

const StoreMetaData: React.FC<StoreMetaDataProps> = ({campaign}) => {
  const {t} = useTranslation('components', {keyPrefix: 'store.storeMetaData'});
  const {backgroundColor} = useThemeContext();

  return (
    <Helmet>
      <meta
        property="og:title"
        content={`${String(t('nftBy'))} ${campaign.merchant.name.replace(
          /"/gu,
          '&quot;'
        )} • ${campaign.collection.name.replace(/"/gu, '&quot;')}`}
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:image"
        content={getImageUrl(import.meta.env.COHORT_ENV, campaign.collection.imageFileKey, {
          w: Sizes.L,
          h: Sizes.L,
          format: 'jpg',
        })}
      />
      <meta property="og:url" content={window.location.href} />
      <meta
        property="og:description"
        content={htmlToText(campaign.store.description).replace(/"/gu, '&quot;')}
      />
      <meta content={backgroundColor} name="theme-color" />
    </Helmet>
  );
};

export default StoreMetaData;
